import React, { useState } from "react";
import { supabase } from "../SupabaseClient.tsx";
import "./LandingPage.css";

type Status = "ready" | "sending" | "done" | "failed";

// Reached from the link in our emails, with or without being signed in. It asks for a click
// rather than unsubscribing on load, because mail scanners open links in emails.
const Unsubscribe: React.FC = () => {
  const token = new URLSearchParams(window.location.search).get("token");
  const [status, setStatus] = useState<Status>("ready");

  const unsubscribe = async () => {
    setStatus("sending");
    const { error } = await supabase.functions.invoke(
      `email-unsubscribe?token=${encodeURIComponent(token ?? "")}`,
      { method: "POST" }
    );
    setStatus(error ? "failed" : "done");
  };

  return (
    <div className="landing-page">
      <div className="landing-container">
        <div className="logo">
          <a href="https://shoebox.io">
            <img src="/logoHorizontal.svg" alt="Shoebox" />
          </a>
        </div>
        <div className="landing-content">
          <div className="sign-in-section">
            <h3>Unsubscribe from Shoebox emails</h3>

            {!token ? (
              <p>This link isn't complete. Email support@shoebox.io and we'll take you off the list.</p>
            ) : status === "done" ? (
              <div className="success-message">
                <p>You're unsubscribed. We won't send you any more of these emails.</p>
              </div>
            ) : (
              <>
                <p className="sign-up-terms">
                  You'll stop getting trial tips and updates. You'll still get account emails like
                  password resets and billing receipts.
                </p>
                {status === "failed" && (
                  <div className="error-message signin-error">
                    We couldn't do that. Try again, or email support@shoebox.io and we'll take you
                    off the list.
                  </div>
                )}
                <button
                  type="button"
                  className="auth-button"
                  onClick={unsubscribe}
                  disabled={status === "sending"}
                >
                  {status === "sending" ? "Processing..." : "Unsubscribe"}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unsubscribe;
